import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinoragadamchennai() {



  const cardData =
  {
    keyword: ' Corporate Cab Service in Oragadam Chennai',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Service in Oragadam Chennai',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Service in Oragadam Chennai, catering to the transportation needs of industrial units, manufacturing plants, and corporate offices in the region. Our fleet of executive sedans, SUVs, and premium vehicles ensures safe, comfortable, and timely travel for employees, clients, and senior management. Whether it is daily staff commute, plant visits, airport transfers, inter-office travel, or VIP transportation, we deliver seamless and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a premium and dependable corporate travel experience for businesses operating in and around Oragadam Chennai.',

    top: 'Top Places to Visit in Chennai with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Marina Beach",
    "description": "Marina Beach is Chennai’s most iconic landmark, stretching over 13 km along the Bay of Bengal. Known for its long sandy shores, it attracts locals and tourists for morning walks, jogging, kite flying, and enjoying street food like sundal and murukku. The beach also hosts cultural events, festivals, and evening gatherings, making it a central hub of leisure and social activity in the city."
  },
  {
    "title": "Kapaleeshwarar Temple",
    "description": "Kapaleeshwarar Temple, located in Mylapore, is a stunning example of Dravidian architecture dedicated to Lord Shiva. Famous for its towering gopuram, colorful sculptures, and serene sanctum, the temple draws devotees and tourists alike. Daily rituals, festivals, and classical music and dance events make it a vibrant cultural and spiritual center in Chennai."
  },
  {
    "title": "Fort St. George",
    "description": "Fort St. George, established in 1644 by the British East India Company, is a historic fortification and administrative hub. It houses St. Mary’s Church, the Tamil Nadu Legislative Assembly, and a museum featuring colonial-era artifacts. Visitors can explore the fort’s ramparts, bastions, and exhibits, gaining insight into Chennai’s colonial past and military architecture."
  },
  {
    "title": "Santhome Cathedral Basilica",
    "description": "Santhome Cathedral Basilica is a majestic Gothic-style church built over the tomb of St. Thomas, one of Jesus Christ’s apostles. Renowned for its stained-glass windows, elegant interiors, and tranquil surroundings, it attracts pilgrims and tourists alike. The basilica is a key spiritual and historical landmark in Chennai."
  },
  {
    "title": "Guindy National Park",
    "description": "Guindy National Park, one of India’s smallest national parks, is located within Chennai city limits. It is home to deer, blackbucks, exotic birds, and reptiles, and also includes the Snake Park and Children’s Park. With walking trails, picnic areas, and serene green spaces, it is ideal for families, nature lovers, and students seeking a natural escape in the city."
  },
  {
    "title": "Valluvar Kottam",
    "description": "Valluvar Kottam is a monument dedicated to the celebrated Tamil poet and philosopher Thiruvalluvar. Its grand chariot-shaped auditorium and intricately carved walls depict his literary works. It serves as a cultural landmark, attracting visitors interested in Tamil literature, history, and architectural artistry."
  },
  {
    "title": "Elliot’s Beach",
    "description": "Elliot’s Beach, located in Besant Nagar, is a calm and scenic alternative to Marina Beach. It is popular for evening walks, jogging, and enjoying serene sunsets. Lined with cafés and eateries, the beach offers a relaxed atmosphere for families, couples, and visitors seeking a peaceful seaside experience."
  },
  {
    "title": "Theosophical Society",
    "description": "The Theosophical Society in Adyar is a sprawling campus featuring lush gardens, century-old trees, and historical buildings. It is a center for spiritual study and meditation, and houses the famous Adyar Banyan Tree. Visitors can enjoy quiet walks, birdwatching, and a peaceful environment reflecting Chennai’s cultural and philosophical heritage."
  },
  {
    "title": "Chennai Rail Museum",
    "description": "The Chennai Rail Museum showcases the evolution of railways in India with vintage locomotives, carriages, photographs, and interactive exhibits. The museum offers miniature train rides, making it educational and entertaining for families, students, and railway enthusiasts. It provides insights into India’s railway history and technological advancements."
  },
  {
    "title": "Semmozhi Poonga",
    "description": "Semmozhi Poonga is a botanical garden in central Chennai featuring themed gardens, landscaped lawns, walking paths, and exotic plant species. It is ideal for morning walks, photography, and peaceful relaxation. The garden provides a green retreat in the midst of the bustling city, attracting families, nature lovers, and tourists."
  }
],


"services": [
{
"name": "Oragadam Industrial Cab",
"description": "Oragadam Industrial Cab provides dedicated transportation solutions for employees and factory staff working across Oragadam’s expansive industrial belt. Equipped with GPS-enabled vehicles, trained drivers, and strict safety protocols, the service supports multi-shift operations, optimized routing, and coordinated fleet management. Ideal for manufacturing units, automotive plants, logistics hubs, and large industrial facilities, it ensures timely workforce movement, reduced transit delays, and dependable end-to-end commute operations."
},
{
"name": "Corporate Shuttle Oragadam",
"description": "Corporate Shuttle Oragadam offers high-capacity shuttle services for companies requiring bulk staff transportation across Oragadam’s industrial and corporate zones. With AC minibuses, centralized scheduling, real-time tracking, automated attendance integrations, and efficiently planned routes, it caters to large organizations managing shift-based movement. The service ensures safe, comfortable, and predictable travel for employees across multiple industrial corridors."
},
{
"name": "Employee Commute Oragadam",
"description": "Employee Commute Oragadam provides structured daily pickup–drop operations for employees working in factories, corporate offices, and industrial units. Featuring shift-wise routing, verified chauffeurs, real-time monitoring, and consistent timing, it guarantees reliable office and plant commute. Built to support companies with varied workforce sizes, it enhances employee punctuality, reduces transport overheads, and ensures smooth daily mobility."
},
{
"name": "Business Cab Oragadam",
"description": "Business Cab Oragadam offers premium corporate travel solutions including client transportation, executive visits, inter-office trips, and airport transfers. With a fleet of modern sedans and SUVs driven by professional chauffeurs, the service ensures comfort, punctuality, and polished corporate hospitality standards. It is ideal for business meetings, factory audits, vendor visits, and senior leadership travel across Oragadam and Chennai."
},
{
"name": "Affordable Office Cab Oragadam",
"description": "Affordable Office Cab Oragadam provides budget-friendly transport solutions for SMEs, mid-sized companies, and growing enterprises operating in Oragadam. Despite economical pricing, it maintains high service standards through trained drivers, optimized routes, well-maintained vehicles, and GPS-enabled monitoring. The service ensures hassle-free, safe, and punctual employee commute without excessive transportation costs."
},
{
"name": "Best Corporate Cabs Oragadam",
"description": "Best Corporate Cabs Oragadam delivers top-tier corporate mobility featuring premium cars, highly trained chauffeurs, and superior service standards. Designed for VIP guests, senior managers, and executive travel requirements, it offers plush interiors, reliable scheduling, and seamless coordination. It supports business meetings, plant visits, hotel transfers, and airport pickups with precision and professionalism."
},
{
"name": "Monthly Cab Oragadam",
"description": "Monthly Cab Oragadam offers long-term contracted cab services for companies looking for consistent and uninterrupted daily transport. It includes dedicated vehicles, driver allocation, maintenance management, fuel handling, and GPS monitoring. Ideal for organizations running multi-shift operations, the service ensures predictable cost planning, improved reliability, and tailored mobility aligned with company schedules."
},
{
"name": "Staff Pickup Drop Oragadam",
"description": "Staff Pickup Drop Oragadam provides structured, multi-route employee transport programs with punctual pickups, optimized routing, digital attendance mapping, and day-long coordination support. Designed for manufacturing and industrial zones, it ensures that employees reach factories and offices on time across all shifts. The service improves workforce efficiency and minimizes transit delays for daily operations."
},
{
"name": "Outstation Cab Oragadam",
"description": "Outstation Cab Oragadam offers long-distance travel solutions for corporate meetings, factory tours, vendor audits, intercity business trips, and executive movement. Equipped with comfortable vehicles, trained chauffeurs, interstate permits, and real-time tracking, it ensures safe, reliable, and well-coordinated outstation travel. The service supports companies with frequent business trips to nearby cities."
},
{
"name": "Sedan Cab Oragadam",
"description": "Sedan Cab Oragadam provides executive sedans ideal for senior staff travel, airport transfers, business engagements, and premium office commute. Each vehicle features comfortable interiors, modern safety features, and is driven by polite, professional drivers. It is suitable for companies seeking refined, comfortable everyday transportation for their management teams."
},
{
"name": "SUV Cab Oragadam",
"description": "SUV Cab Oragadam offers spacious and high-performance SUVs for team mobility, senior leadership travel, outstation journeys, and long corporate drives. With superior riding comfort, additional luggage space, and enhanced road stability, this service is ideal for companies prioritizing safety, comfort, and reliability for their top-tier mobility needs."
},
{
"name": "Factory Transport Oragadam",
"description": "Factory Transport Oragadam is designed specifically for large-scale industrial operations requiring massive workforce movement across shifts. Featuring buses, minibuses, staff vans, and coordinated driver teams, the service ensures safe, timely, and compliant transportation for factory workers. It supports lean manufacturing operations by minimizing delays and keeping shift transitions smooth and efficient."
},
{
"name": "Company Cab Oragadam",
"description": "Company Cab Oragadam provides end-to-end corporate transportation solutions including employee taxi services, executive cars, visitor transfers, and fleet allocation for daily operations. The service includes professional drivers, GPS supervision, vehicle maintenance, and customizable commuting plans tailored to organizational requirements across Oragadam’s industrial cluster."
},
{
"name": "Employee Mobility Oragadam",
"description": "Employee Mobility Oragadam offers technology-driven workforce transport management with smart scheduling, automated routing, trip analytics, multi-shift support, and live monitoring. Designed for companies managing large employee bases, it enhances safety, reduces commute complexity, and delivers a smooth, organized, and scalable mobility experience for employees working in Oragadam’s industrial ecosystem."
},
{
"name": "Corporate Fleet Oragadam",
"description": "Corporate Fleet Oragadam provides comprehensive fleet outsourcing services offering sedans, SUVs, shuttles, and industrial transport vehicles. With complete driver management, compliance handling, routine maintenance, GPS oversight, and scalable fleet deployment, it helps companies run efficient, cost-effective, and professionally supervised mobility operations across Oragadam’s corporate and industrial regions."
}
],

"tableData": [
["Oragadam Industrial Cab", "Corporate Shuttle Oragadam"],
["Employee Commute Oragadam", "Business Cab Oragadam"],
["Affordable Office Cab Oragadam", "Best Corporate Cabs Oragadam"],
["Monthly Cab Oragadam", "Staff Pickup Drop Oragadam"],
["Outstation Cab Oragadam", "Sedan Cab Oragadam"],
["SUV Cab Oragadam", "Factory Transport Oragadam"],
["Company Cab Oragadam", "Employee Mobility Oragadam"],
["Corporate Fleet Oragadam", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Service in Oragadam Chennai",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides dependable corporate cab services in Oragadam Chennai, ensuring efficient and comfortable transportation for employees and business executives."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We ensure punctual pickups and drop-offs across Oragadam’s industrial corridors, manufacturing hubs, and corporate facilities, helping employees reach on time."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our professional chauffeurs offer safe, disciplined, and courteous travel, ensuring a secure and comfortable commute for corporate staff and visitors."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from a wide range of sedans, SUVs, tempo travellers, and buses—all regularly sanitized, serviced, and maintained for smooth corporate travel in Oragadam."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We offer flexible and customized transport solutions designed to meet the commuting needs of employees and businesses in Oragadam’s industrial zone."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock for bookings, urgent travel requirements, and route adjustments, ensuring uninterrupted mobility."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles undergo routine sanitization and are equipped with modern safety features, ensuring corporate passengers enjoy hygienic and secure rides."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "We streamline corporate travel management with easy booking options and reliable coordination, ensuring hassle-free employee transportation."
  }
]







































  }

  
const faqData = [
  {
    question: 'Do you provide corporate cab services in Oragadam, Chennai?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers professional and reliable corporate cab services for companies and industries located in Oragadam, Chennai.',
  },
  {
    question: 'What types of corporate transportation services do you offer in Oragadam?',
    answer: 'We provide employee transportation, factory-to-home shuttle services, corporate pickups and drops, airport transfers, and complete fleet management for industrial and corporate zones.',
  },
  {
    question: 'Do you support daily commute services for industries in Oragadam?',
    answer: 'Yes, we offer daily employee commute solutions with optimized routes, punctual pickups, and support for multi-shift operations.',
  },
  {
    question: 'How can companies book corporate cab services in Oragadam?',
    answer: 'Companies can book through our website, mobile app, or by contacting our 24×7 dedicated corporate support team.',
  },
  {
    question: 'What vehicle options are available for corporate cab services in Oragadam?',
    answer: 'We offer sedans, SUVs, hatchbacks, Innova Crysta, tempo travellers, luxury cars, and electric cabs as per company requirements.',
  },
  {
    question: 'Do you offer long-term corporate cab contracts in Oragadam?',
    answer: 'Yes, we provide monthly, quarterly, and annual corporate transportation contracts, with flexible pricing and end-to-end fleet management.',
  },
  {
    question: 'Are your vehicles equipped with GPS and safety features?',
    answer: 'Absolutely. All our vehicles are GPS-enabled, sanitized regularly, and driven by background-verified and trained chauffeurs.',
  },
  {
    question: 'Do you support night shift and 24×7 industrial operations?',
    answer: 'Yes, we provide transportation for day shifts, night shifts, weekend operations, and rotational employee schedules in Oragadam.',
  },
  {
    question: 'What payment options are available for companies using your corporate cab services?',
    answer: 'We accept UPI, bank transfers, digital wallets, credit/debit cards, and also provide consolidated monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Selvam Rajendran',
    feedback: 'Reliable and professional cab services for our Oragadam plant. Drivers are disciplined and always on time.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Kavitha Srinivasan',
    feedback: 'Excellent transportation partner for our industrial operations. Clean vehicles and smooth coordination every day.',
    rating: 5,
  },
];








































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Oragadam Chennai",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-oragadam.jpg", // replace with real image URL
  "description":
    "Pune Corporate Cars India Private Limited delivers reliable corporate cab services in Oragadam Chennai, offering industrial employee transport, corporate shuttles, business cabs, affordable office commute solutions, monthly cab plans, staff pickup & drop, outstation corporate travel, and complete fleet management solutions for companies in the Oragadam industrial belt.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-service-oragadam-chennai"
  }
};






  return (
    <div>
      <Helmet>
  <title>Corporate Cab Service in Oragadam Chennai | Industrial & Employee Transport</title>

  <meta
    name="description"
    content="Corporate cab services in Oragadam Chennai including industrial employee transport, corporate shuttles, office commute solutions, monthly cabs, staff pickup & drop, outstation corporate travel, and complete fleet services."
  />

  <meta
    name="keywords"
    content="Oragadam Industrial Cab, Corporate Shuttle Oragadam, Employee Commute Oragadam, Business Cab Oragadam, Affordable Office Cab Oragadam, Best Corporate Cabs Oragadam, Monthly Cab Oragadam, Staff Pickup Drop Oragadam, Outstation Cab Oragadam, Sedan Cab Oragadam, SUV Cab Oragadam, Factory Transport Oragadam, Company Cab Oragadam, Employee Mobility Oragadam, Corporate Fleet Oragadam"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/75.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinoragadamchennai;